import React from "react";
import { colors } from "../../constants/theme";
import Image from "../../assets/images/product-img.png";

const Home = () => {
  const data = [
    { title: "firewalls", path: "", isActive: false },
    { title: "laptops & desktops", path: "", isActive: true },
    { title: "ip phones", path: "", isActive: false },
    { title: "smart homes system", path: "", isActive: false },
    { title: "it hardwares/ softwares", path: "", isActive: false },
  ];
  return (
    <div>
      <div
        style={{ background: colors.blueColor }}
        className="w-full pt-32 pb-14 px-10 md:px-24"
      >
        <div className="h-[15px] w-[80px] bg-pink-600 my-2" />
        <h1 className="uppercase font-normal text-2xl text-white">products</h1>
      </div>
      {/* Home */}
      <div className="md:w-[500px] w-full bg-zinc-100 md:mx-auto md:px-16 px-10 py-12 my-20">
        <h1 className="text-center font-bold text-pink-600 text-3xl uppercase">
          products
        </h1>
        <p className="font-light text-black text-sm text-left mt-8">
          Our company offers the best and most reliable laptops, desktops, IT
          hardware/software, smart home services, IP phones services and
          firewalls available. Our products are tailored to meet your specific
          needs, ensuring that your business runs smoothly and efficiently.
        </p>
        <p className="font-light text-black text-sm text-left mt-8">
          Also, we are always on the cutting edge of technology, and our expert
          customer service team is ready to help with any issue you may have.
          Whether you're a large business or small home office, RemotewebNET has
          the products and services to meet your needs.
        </p>
      </div>
      {/* Line */}
      <div
        style={{ background: colors.blueColor }}
        className="h-[0.5px] md:w-[700px] w-full my-10 md:mx-auto"
      />
      {/* COntent */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 md:space-x-16 max-w-[1240px] lg:mx-32 md:mx-32 mx-10 py-10 md:py-10">
        <div className="my-2 py-5" style={{}}>
          <div className="flex items-center">
            <h1
              style={{ color: colors.blueColor }}
              className="uppercase font-medium text-2xl mr-6"
            >
              laptops/desktops
            </h1>
          </div>
          <div>
            <p className="font-light text-black text-sm text-left mt-8">
              With RemotewebNET's Sophos Firewall Solution, you can get
              effective network security and performance in Abuja, Nigeria. The
              next-generation firewall for application acceleration, high
              performance, TLS inspection, and strong threat protection is
              Sophos Firewall.
            </p>
            <p className="font-light text-black text-sm text-left mt-8">
              The Sophos Firewall is designed to provide complete defense
              against the most recent ransomware and malware attacks on your
              network. To provide our clients in Nigeria with top-notch network
              security, RemotewebNET has teamed up with Sophos. We promise to
              provide you with the security required to operate effectively and
              safely in the hybrid and varied business settings of today.
            </p>
          </div>
        </div>
        <div className=" col-span-2 my-2 py-10 px-4 relative">
          <img src={Image} alt="Products" />
          <div className="flex justify-center">
            <button
              style={{}}
              className="text-white border bg-pink-600 border-pink-600
    hover:bg-transparent hover:text-pink-600 rounded-sm py-3 px-8 font-medium -mt-6"
            >
              Laptops and Desktops
            </button>
          </div>
        </div>
      </div> */}

      {/* Bottom Button */}
      {/* <div className="mx-36 flex justify-center items-center flex-wrap mb-14">
        {data.map((item, index) => (
          <div
            key={index}
            className={`flex items-center justify-center uppercase text-lg py-8 w-[250px] h-[100px] text-center px-4  ${
              item.isActive
                ? " bg-blue-900 text-white"
                : " bg-zinc-100 text-black font-light"
            }`}
          >
            {item.title}
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default Home;
